<div *ngIf="show" [style.background]="bk" [style.color]="color" class="process animated fadeIn faster">
  <div class="process-div">
    <div style="display: grid">
      <div class="loader"></div>
    </div>
    <div class="text">{{ text.toUpperCase() }}</div>
  </div>
</div>
